import { render, staticRenderFns } from "./ListaMessaggi.vue?vue&type=template&id=bc179352"
import script from "./ListaMessaggi.vue?vue&type=script&lang=js"
export * from "./ListaMessaggi.vue?vue&type=script&lang=js"
import style0 from "./ListaMessaggi.vue?vue&type=style&index=0&id=bc179352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports